/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

  export class MeevoLocationSelector implements angular.IDirective {
    restrict = "E";
    templateUrl = "app/components/locationSelector/locationSelector.template.html";
    bindToController = true;
    controller = Meevo.Components.Controls.LocationSelectorController;
    controllerAs = 'locationSelector';
    require = [
        "meevoLocationSelector",
        "ngModel"
    ];
    scope = {
        onSwitchLocation: '&onSwitchLocation',
        contentKey: "@",
        disabled: '=?ngDisabled'
    };
    link = (scope: any, element: JQuery, attr: angular.IAttributes, [ctrl, ngModel]) => {
        ctrl.ngModel = ngModel; 
        ctrl.init();
    };

    static factory(): angular.IDirectiveFactory {
      let directive = () => {
          return new MeevoLocationSelector();
      };

      return directive;
    }
  }

  angular.module("meevo.components.controls")
      .directive("meevoLocationSelector", MeevoLocationSelector.factory());
}